export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20representing%20breaking%20news%20and%20entertainment%20gossip%20culture%2C%20warm%20deep%20red%20and%20dark%20crimson%20tones%20with%20golden%20accents%2C%20dramatic%20modern%20editorial%20design%2C%20dark%20atmospheric%20background%20with%20soft%20glowing%20elements%2C%20stylized%20digital%20media%20concept%2C%20cinematic%20mood%2C%20textured%20layered%20composition%2C%20no%20text%20no%20faces&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="吃瓜爆料 - 全网热点爆料聚合平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold tracking-wide mb-6">
              <i className="ri-flashlight-fill"></i>
              <span>每日更新 · 真实爆料 · 持续追踪</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              吃瓜爆料
              <span className="block text-accent-400 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">
                全网热点爆料聚合平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-background-200/90 font-heading font-semibold mb-6">
              吃瓜第一线，爆料最前线
            </p>

            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              吃瓜爆料是国内领先的娱乐热点聚合平台，汇集全网最新吃瓜爆料黑料、吃瓜爆料视频与吃瓜爆料每日大赛精彩内容。
              我们以每日热点爆料吃瓜为核心，实时追踪娱乐圈、网红圈、社会热点事件，为吃瓜群众提供第一手热门爆料资讯。
              当前平台正聚焦多起重磅事件追踪，热门话题持续发酵中，精彩不容错过。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</div>
                <div className="text-xs text-background-300/70 mt-1">全天候更新</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">100+</div>
                <div className="text-xs text-background-300/70 mt-1">每日新增爆料</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">实时</div>
                <div className="text-xs text-background-300/70 mt-1">匿名安全投稿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-fire-fill mr-2"></i>查看最新爆料
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-semibold rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-colors whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-send-plane-fill mr-2"></i>我要投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20composition%20with%20warm%20deep%20red%20crimson%20and%20dark%20tones%2C%20golden%20highlights%2C%20abstract%20news%20media%20concept%2C%20layered%20geometric%20elements%20with%20soft%20glow%2C%20modern%20magazine%20cover%20aesthetic%2C%20luxurious%20textured%20dark%20background%2C%20no%20text%20no%20people&width=800&height=700&seq=hero-visual-main&orientation=portrait"
                alt="吃瓜爆料热点聚合主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}